import store from './store'
import TicketSaleSelectors from '../ducks/ticket-sale/ticket-sale.selectors'

const getState = (store) => ({
	conexao: store.conexao,
	isBusSelectionGoingStep: TicketSaleSelectors.isBusSelectionGoingStep(store),
	store2: store,
	tripPrice: store.tripPrice,
})

function calculatePrices({
	price,
	upgradeTo,
	canUpgrade,
	forReturnTrip,
	conversionParameters,
	busCompany,
	promotionPercent,
}) {
	const roundFunction = forReturnTrip ? Math.floor : Math.ceil

	if (!busCompany) {
		return []
	}

	return conversionParameters
		.filter((c) => c.busCompany.toUpperCase() === busCompany.toUpperCase())
		.map(
			({
				pointValue,
				valueFactor,
				forSubscribers,
				pointsPercentage,
				conversionParameterId,
			}) => {
				const valorOriginal = price

				const valorACobrar =
					roundFunction(
						price *
							(pointsPercentage == 0 ? valueFactor : 1) *
							(100 - pointsPercentage)
					) / 100
				const valorAExibir =
					roundFunction(
						price *
							(pointsPercentage == 0 ? valueFactor : 1) *
							((100 - promotionPercent) / 100) *
							(100 - pointsPercentage)
					) / 100

				const pontosACobrar = roundFunction(
					(price * valueFactor * pointsPercentage) / pointValue / 100
				)

				const pontosAExibir = roundFunction(
					(price *
						((100 - promotionPercent) / 100) *
						valueFactor *
						pointsPercentage) /
						pointValue /
						100
				)

				return {
					forSubscribers,
					id: conversionParameterId,
					value: valorACobrar,
					points: pontosACobrar,
					upgradePrices: canUpgrade
						? calculatePrices({
								forReturnTrip,
								promotionPercent,
								conversionParameters,
								busCompany: busCompany,
								price: upgradeTo.price,
						  })
						: [],
					upgradeBusClass: canUpgrade ? upgradeTo.busClass : '',
					originalValue: valorOriginal,
					promotionPercent,
					valueToShow: valorAExibir,
					pointsToShow: pontosAExibir,
				}
			}
		)
}

function calculateWithDiscount(
	precoEscolhido,
	percentualDesconto,
	precoPassagem,
	orderSumary = false
) {
	const real = precoEscolhido.value > 0 && precoEscolhido.points == 0
	const pontos = precoEscolhido.value == 0 && precoEscolhido.points > 0
	const pontosreal = precoEscolhido.value > 0 && precoEscolhido.points > 0
	const roundMoneyFuncion = (value) =>
		Math.round((value + Number.EPSILON) * 100) / 100
	const clube = precoEscolhido.forSubscribers

	if (precoPassagem == null) {
		precoPassagem = {
			tax: 0,
			fee: 0,
			toll: 0,
			price: 0,
			insurance: 0,
		}
	}

	const objPrice = {
		tarifa: precoPassagem.tax != null ? precoPassagem.tax : 0,
		imposto: precoPassagem.fee != null ? precoPassagem.fee : 0,
		pedagio: precoPassagem.toll != null ? precoPassagem.toll : 0,
		preco: precoPassagem.price != null ? precoPassagem.price : 0,
		seguro: precoPassagem.insurance != null ? precoPassagem.insurance : 0,
		pontos: precoEscolhido.points,
		valorAExibir: precoEscolhido.valueToShow,
		valorACobrar: precoEscolhido.value,
		valorDesconto: 0,
		pontosDesconto: 0,
		valorDescontoClube: 0,
	}
	if (real) {
		//##REAL
		if (clube) {
			//Desconto da poltrona amarela
			objPrice.valorDesconto = roundMoneyFuncion(
				(precoEscolhido.value - objPrice.imposto - objPrice.pedagio) *
					(percentualDesconto / 100)
			)
			let valorACobrarAntesDoClube = objPrice.valorACobrar
			objPrice.valorACobrar -= objPrice.valorDesconto

			//Somar desconto do clube para exibição
			objPrice.valorDescontoClube =
				objPrice.tarifa +
				objPrice.imposto +
				objPrice.pedagio -
				valorACobrarAntesDoClube
		}
		if (!clube) {
			if (percentualDesconto > 0) {
				objPrice.valorDesconto = roundMoneyFuncion(
					objPrice.tarifa * (percentualDesconto / 100)
				)
				objPrice.pontosDesconto = Math.round(
					objPrice.pontos * (percentualDesconto / 100)
				)
				objPrice.valorACobrar -= objPrice.valorDesconto
				objPrice.pontos -= objPrice.pontosDesconto
			}
		}
	}

	if (pontosreal) {
		//##PONTOS+REAL -- Clube e não clube é o mesmo cálculo
		objPrice.tarifa =
			precoEscolhido.value - objPrice.imposto - objPrice.pedagio

		var precoSelecionadoValor = precoEscolhido.value
		var precoSelecionadoPontos = precoEscolhido.points
		const { conexao, isBusSelectionGoingStep, tripPrice } = getState(
			store.getState()
		)

		if (
			conexao != null &&
			conexao.ehConexaoIda &&
			(isBusSelectionGoingStep || orderSumary)
		) {
			const conexaoTrechoAtual =
				conexao.conexaoIda.trecho[parseInt(conexao.ordemViagemIda) - 1]

			const roundFunction = !isBusSelectionGoingStep ? Math.floor : Math.ceil

			//Obtendo pontos e reais
			var conversion = tripPrice.conversionParameters
				.filter(
					(c) =>
						c.busCompany.toUpperCase() ===
						conexaoTrechoAtual.enterprise.toUpperCase()
				)
				.filter((c) => c.pointsPercentage < 100)
				.filter((c) => c.pointsPercentage > 0)
				.filter((c) => c.forSubscribers === precoEscolhido.forSubscribers)

			var pontosRecalculados = conversion.map(
				({
					pointValue,
					valueFactor,
					pointsPercentage,
					conversionParameterId,
				}) => {
					const valorACobrar =
						roundFunction(
							precoPassagem.price *
								(pointsPercentage == 0 ? valueFactor : 1) *
								(100 - pointsPercentage)
						) / 100
					const valorAExibir =
						roundFunction(
							precoPassagem.price *
								(pointsPercentage == 0 ? valueFactor : 1) *
								((100 - percentualDesconto) / 100) *
								(100 - pointsPercentage)
						) / 100

					const pontosACobrar = roundFunction(
						(precoPassagem.price * valueFactor * pointsPercentage) /
							pointValue /
							100
					)

					const pontosAExibir = roundFunction(
						(precoPassagem.price *
							((100 - percentualDesconto) / 100) *
							valueFactor *
							pointsPercentage) /
							pointValue /
							100
					)

					return {
						value: valorACobrar,
						originalValue: precoPassagem.tax,
						valueToShow: valorAExibir,
						points: pontosACobrar,
						pointsToShow: pontosAExibir,
						id: conversionParameterId,
					}
				}
			)
			precoSelecionadoPontos = pontosRecalculados[0].points
			objPrice.pontos = pontosRecalculados[0].points
			precoSelecionadoValor = pontosRecalculados[0].value
			objPrice.tarifa =
				precoSelecionadoValor - objPrice.imposto - objPrice.pedagio
		}

		if (percentualDesconto > 0) {
			objPrice.valorDesconto = roundMoneyFuncion(
				(precoSelecionadoValor - objPrice.imposto - objPrice.pedagio) *
					(percentualDesconto / 100)
			)
			objPrice.pontosDesconto = Math.round(
				precoSelecionadoPontos * (percentualDesconto / 100)
			)
			objPrice.valorACobrar -= objPrice.valorDesconto

			objPrice.pontos -= objPrice.pontosDesconto
		}
	}

	if (pontos) {
		//##PONTOS -- Clube e não clube é o mesmo cálculo
		objPrice.tarifa = 0
		objPrice.imposto = 0
		objPrice.pedagio = 0

		const { conexao, isBusSelectionGoingStep, tripPrice } = getState(
			store.getState()
		)
		if (conexao && conexao.conexaoIda) {
			const roundFunction = !isBusSelectionGoingStep ? Math.floor : Math.ceil
			const conexaoTrechoAtual =
				conexao.conexaoIda.trecho[parseInt(conexao.ordemViagemIda) - 1]
			//Obtendo pontos e reais
			var conversion = tripPrice.conversionParameters
				.filter(
					(c) =>
						c.busCompany.toUpperCase() ===
						conexaoTrechoAtual.enterprise.toUpperCase()
				)
				.filter((c) => c.pointsPercentage === 100)
				.filter((c) => c.forSubscribers === precoEscolhido.forSubscribers)
			var pontosRecalculados = conversion.map(
				({
					pointValue,
					valueFactor,
					pointsPercentage,
					conversionParameterId,
				}) => {
					const valorACobrar =
						roundFunction(
							precoPassagem.price *
								(pointsPercentage == 0 ? valueFactor : 1) *
								(100 - pointsPercentage)
						) / 100
					const valorAExibir =
						roundFunction(
							precoPassagem.price *
								(pointsPercentage == 0 ? valueFactor : 1) *
								((100 - percentualDesconto) / 100) *
								(100 - pointsPercentage)
						) / 100
					const pontosACobrar = roundFunction(
						(precoPassagem.price * valueFactor * pointsPercentage) /
							pointValue /
							100
					)
					const pontosAExibir = roundFunction(
						(precoPassagem.price *
							((100 - percentualDesconto) / 100) *
							valueFactor *
							pointsPercentage) /
							pointValue /
							100
					)
					return {
						value: valorACobrar,
						originalValue: precoPassagem.tax,
						valueToShow: valorAExibir,
						points: pontosACobrar,
						pointsToShow: pontosAExibir,
						id: conversionParameterId,
					}
				}
			)
			objPrice.pontos = pontosRecalculados[0].points
		}

		if (percentualDesconto > 0) {
			objPrice.pontosDesconto = Math.round(
				precoEscolhido.points * (percentualDesconto / 100)
			)
			objPrice.pontos -= objPrice.pontosDesconto
		}
	}
	return objPrice
}

const tripPriceHelper = {
	calculatePrices,
	calculateWithDiscount,
}

export default tripPriceHelper
